import _ from 'lodash';
import { SortDescriptor } from '@progress/kendo-data-query';

export default class ProductsUtils {
    //public static flatMapProducts(productItems: any[]): any[] {

    //    return _.forEach(productItems, (p: any) => {
    //        _.forEach(p.attributes, (att: any) => {
    //            let value = null;

    //            switch (att.type.toLowerCase()) {
    //                case "enumeration":
    //                    let eValues = att.localizedValues as [];
    //                    if (eValues) {
    //                        value = _.join(_.flatMap(eValues, (eValue) => eValues[eValue]), ', ');
    //                    }

    //                    break;
    //                default:
    //                    value = att.value;
    //                    break;
    //            };

    //            p[att.optionCode] = value;
    //        })
    //    });
    //}

    public static orderBy(products: any[], sort: SortDescriptor[]): any[] {
        return _.orderBy(products,
            _.map(sort, (s) => s.field.toLocaleUpperCase() == '#PRODUCT_NAME#' ? 'name' : s.field),
            _.map(sort, (s) => s.dir?.toLowerCase() == "desc" ? "desc" : "asc"));
    }

    public static page(products: any[], skip: number, take: number): any[] {
        return _.slice(products, skip, skip + take);
    }

    public static getOrderByQueryStringParam(sort: SortDescriptor[]): string {
        return _.map(sort, (s) => `${s.field.replaceAll('#', '@')}__${s.dir || 'asc'}`).join(',');
    }

    public static getSortByOrderByQueryStringParam(sortQueryString: string): SortDescriptor[] {
        var outSort: SortDescriptor[] = [];

        var sortRules = sortQueryString.split(',');

        for (var i = 0; i < sortRules.length; i++) {
            var sortRule = sortRules[i];

            var indexOfDirection = sortRule.lastIndexOf('__');

            if (indexOfDirection >= 0) {
                var sortField = sortRule.substring(0, indexOfDirection).replaceAll('@', '#');
                var sortDirection = sortRule.substring(indexOfDirection + 2).toLowerCase();

                outSort.push({ field: sortField, dir: sortDirection == 'desc' ? 'desc' : 'asc' });
            }
        }

        return outSort;
    }

    public static toKendoGridList(products: any[]): any[] {
        
        var groups: any = [];
        var lastMasterName = null;

        for (var i = 0; i < products.length; i++) {
            var product = products[i];

            if (!lastMasterName || lastMasterName != product.masterName) {
                groups.push({
                    field: 'masterName',
                    value: product.masterName,
                    items: []
                })

                lastMasterName = product.masterName;
            }

            groups[groups.length - 1].items.push(product);
        }

        return groups;
    }
}